import { TOP_DISTANCE, NO_OF_ITEMS, Y_DISTANCE,  X_DISTANCE } from "../../config/Game";
 

const animateOpacity = (ball: any, onAnimationEnds: any) => {
	for (let opacity = 0; opacity <= 1; opacity = opacity + 0.1) 
	{           
			//@ts-ignore
			setTimeout(function(){
				ball.style.opacity = opacity;  
				if(opacity > 0.99) {
					onAnimationEnds();
				}
			},100);                       
	}  
}

const getNumberPosition = (number: number) => {

	const top = TOP_DISTANCE + Math.floor(number/NO_OF_ITEMS) * Y_DISTANCE;
	const left = Math.floor(number%NO_OF_ITEMS) * X_DISTANCE + 5;

	return { 
		top: top + '%', 
		left: left + '%' 
	}
}

const animateBall = (ball: any, _number: number, onAnimationEnds: any) => {
	animateOpacity(ball, () => {
		ball.classList.add('is-drawn');
	
		setTimeout(() => {
			let position = getNumberPosition(_number)
			ball.style.top = position.top;
			ball.style.left = position.left;
			ball.classList.add('is-placed');
		}, 500);

		setTimeout(() => {
			onAnimationEnds(); 
		}, 1200);
		
	});

}


export default animateBall